/* eslint-disable no-case-declarations */
import { GET_GROUPS_FAILURE, GET_GROUPS_STARTED, GET_GROUPS_SUCCESS } from "actions/sync/challenge_steps/Constants"
import { ADD_CHALLENGEDRAFT_ID_IMAGE_FAILURE, ADD_CHALLENGEDRAFT_ID_IMAGE_STARTED, ADD_CHALLENGEDRAFT_ID_IMAGE_SUCCESS, DELETE_CHALLENGEDRAFT_ID_IMAGE_FAILURE, DELETE_CHALLENGEDRAFT_ID_IMAGE_STARTED, DELETE_CHALLENGEDRAFT_ID_IMAGE_SUCCESS, GET_CHALLENGEINTOINNOVATE_DRAFT_FAILURE, GET_CHALLENGEINTOINNOVATE_DRAFT_STARTED, GET_CHALLENGEINTOINNOVATE_DRAFT_SUCCESS, GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_FAILURE, GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_STARTED, GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_SUCCESS, GET_INNOVATE_CHALLENGE_ALL_LIST_FAILURE, GET_INNOVATE_CHALLENGE_ALL_LIST_STARTED, GET_INNOVATE_CHALLENGE_ALL_LIST_SUCCESS, GET_INNOVATE_CHALLENGE_FAILURE, GET_INNOVATE_CHALLENGE_FILTER_LIST_FAILURE, GET_INNOVATE_CHALLENGE_FILTER_LIST_STARTED, GET_INNOVATE_CHALLENGE_FILTER_LIST_SUCCESS, GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_FAILURE, GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_STARTED, GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_SUCCESS, GET_INNOVATE_CHALLENGE_STARTED, GET_INNOVATE_CHALLENGE_SUCCESS, GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_FAILURE, GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_STARTED, GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_SUCCESS, POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_FAILURE, POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_STARTED, POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_SUCCESS, POST_INNOVATE_CHALLENGE_CREATE_FAILURE, POST_INNOVATE_CHALLENGE_CREATE_STARTED, POST_INNOVATE_CHALLENGE_CREATE_SUCCESS, POST_INNOVATE_CHALLENGE_DRAFT_FAILURE, POST_INNOVATE_CHALLENGE_DRAFT_STARTED, POST_INNOVATE_CHALLENGE_DRAFT_SUCCESS, PUT_INNOVATE_CHALLENGE_EDIT_FAILURE, PUT_INNOVATE_CHALLENGE_EDIT_STARTED, PUT_INNOVATE_CHALLENGE_EDIT_SUCCESS } from "actions/sync/innovate/challenge/Constants"


const initialState = {
  listInnovateCommunitesChallengeLoading:false,
  listInnovateChallengeLoading: false,
  createInnovateChallengeLoading: false,
  editInnovateChallengeLoading: false,
  DraftInnovateChallengeLoading:false,
  draftGetInnovateChallengeLoading:false,
  innovateTypeLoading:false,
  getInnovateChallengeDraftIdAddImageLoading:false,
  getInnovateChallengeDraftIdDeleteImageLoading:false,
  getInnovateChallengeIdDetailsLoading:false,
   filterListInnovateChallengeLoading:false,
   postInnovateChallengeRemoveEvaluatorIsLoading:false,
   getInnovateChallengeListRemoveEvaluatorIsLoading:false,
   getIdeaListFromChallengeRemoveEvaluatorIsLoading:false,
   getIdeaListFromChallengeRemoveEvaluator:[],
   getInnovateChallengeListRemoveEvaluator:[],
   postInnovateChallengeRemoveEvaluator:[],
  filterListInnovateChallenge:[],
  getInnovateChallengeDraftIdDeleteImage:[],
  listInnovateChallenge:[],
  listInnovateCommunitesChallenge:[],
  createInnovateChallenge:[],
  editInnovateChallenge:[],
  DraftInnovateChallenge:[],
  innovateCategoryTypes:[],
  draftGetInnovateChallenge:[],
  getInnovateChallengeDraftIdAddImage:[],
  getInnovateChallengeIdDetails:[]

}


const InnovateChallengeReducer = (state = initialState, action) => {
  switch (action.type) {
    
      case GET_INNOVATE_CHALLENGE_FILTER_LIST_STARTED:
      return {
        ...state,
        filterListInnovateChallengeLoading: true,
      }
    case GET_INNOVATE_CHALLENGE_FILTER_LIST_SUCCESS:
      const newItems = Array.from(new Set([...state.filterListInnovateChallenge, ...action.response.data]));
      return {
        ...state,
        filterListInnovateChallenge: action.response.data,
        filterListInnovateChallengeUpdated: newItems,
        filterListInnovateChallengeLoading: false,
        items: action.response.items,
        hasMore:newItems.length < action.response.total,
        total:action.response.total,

      }
    case GET_INNOVATE_CHALLENGE_FILTER_LIST_FAILURE:
      return {
        ...state,
        filterListInnovateChallengeLoading: false
      }

    case GET_INNOVATE_CHALLENGE_ALL_LIST_STARTED:
      return {
        ...state,
        listInnovateChallengeLoading: true,
      }
    case GET_INNOVATE_CHALLENGE_ALL_LIST_SUCCESS:
      return {
        ...state,
        listInnovateChallenge: action.response,
        listInnovateChallengeLoading: false,
      }
    case GET_INNOVATE_CHALLENGE_ALL_LIST_FAILURE:
      return {
        ...state,
        listInnovateChallengeLoading: false
      }
    case POST_INNOVATE_CHALLENGE_CREATE_STARTED:
      return {
        ...state,
        createInnovateChallengeLoading: true,
      }
    case POST_INNOVATE_CHALLENGE_CREATE_SUCCESS:
      return {
        ...state,
        createInnovateChallenge: action.response,
        createInnovateChallengeLoading: false,
      }
    case POST_INNOVATE_CHALLENGE_CREATE_FAILURE:
      return {
        ...state,
        createInnovateChallengeLoading: false
      }

    case PUT_INNOVATE_CHALLENGE_EDIT_STARTED:
      return {
        ...state,
        editInnovateChallengeLoading: true,
      }
    case PUT_INNOVATE_CHALLENGE_EDIT_SUCCESS:
      return {
        ...state,
        editInnovateChallenge: action.response,
        editInnovateChallengeLoading: false,
      }
    case PUT_INNOVATE_CHALLENGE_EDIT_FAILURE:
      return {
        ...state,
        editInnovateChallengeLoading: false
      }

    case POST_INNOVATE_CHALLENGE_DRAFT_STARTED:
      return {
        ...state,
        DraftInnovateChallengeLoading: true,
      }
    case POST_INNOVATE_CHALLENGE_DRAFT_SUCCESS:
      return {
        ...state,
        DraftInnovateChallenge: action.response,
        DraftInnovateChallengeLoading: false,
      }
    case POST_INNOVATE_CHALLENGE_DRAFT_FAILURE:
      return {
        ...state,
        DraftInnovateChallengeLoading: false
      }
    
    case GET_GROUPS_STARTED:
      return {
        ...state,
        listInnovateCommunitesChallengeLoading: true,
      }
    case GET_GROUPS_SUCCESS:
      return {
        ...state,
        listInnovateCommunitesChallenge: action.response,
        listInnovateCommunitesChallengeLoading: false,
      }
    case GET_GROUPS_FAILURE:
      return {
        ...state,
        listInnovateCommunitesChallengeLoading: false
      }

      case GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_STARTED:
        return {
          ...state,
          innovateTypeLoading:true
        }
      case GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_SUCCESS:
        return {
          ...state,
          innovateCategoryTypes: action.response.types,
          innovateTypeLoading:false
        }
      case GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_FAILURE:
        return {
          ...state,
          innovateTypeLoading:false
        }

      case GET_CHALLENGEINTOINNOVATE_DRAFT_STARTED:
        return {
          ...state,
          draftGetInnovateChallengeLoading:true
        }
      case GET_CHALLENGEINTOINNOVATE_DRAFT_SUCCESS:
        return {
          ...state,
          draftGetInnovateChallenge: action.response,
          draftGetInnovateChallengeLoading:false
        }
      case GET_CHALLENGEINTOINNOVATE_DRAFT_FAILURE:
        return {
          ...state,
          draftGetInnovateChallengeLoading:false
        }

      case ADD_CHALLENGEDRAFT_ID_IMAGE_STARTED:
        return {
          ...state,
          getInnovateChallengeDraftIdAddImageLoading:true
        }
      case ADD_CHALLENGEDRAFT_ID_IMAGE_SUCCESS:
        return {
          ...state,
          getInnovateChallengeDraftIdAddImage: action.response,
          getInnovateChallengeDraftIdAddImageLoading:false
        }
      case ADD_CHALLENGEDRAFT_ID_IMAGE_FAILURE:
        return {
          ...state,
          getInnovateChallengeDraftIdAddImageLoading:false
        }

      case DELETE_CHALLENGEDRAFT_ID_IMAGE_STARTED:
        return {
          ...state,
          getInnovateChallengeDraftIdDeleteImageLoading:true
        }
      case DELETE_CHALLENGEDRAFT_ID_IMAGE_SUCCESS:
        return {
          ...state,
          getInnovateChallengeDraftIdDeleteImage: action.response,
          getInnovateChallengeDraftIdDeleteImageLoading:false
        }
      case DELETE_CHALLENGEDRAFT_ID_IMAGE_FAILURE:
        return {
          ...state,
          getInnovateChallengeDraftIdDeleteImageLoading:false
        }


      case GET_INNOVATE_CHALLENGE_STARTED:
        return {
          ...state,
          getInnovateChallengeIdDetailsLoading:true
        }
      case GET_INNOVATE_CHALLENGE_SUCCESS:
        return {
          ...state,
          getInnovateChallengeIdDetailsLoading:false,
          getInnovateChallengeIdDetails: action.response
          
        }
      case GET_INNOVATE_CHALLENGE_FAILURE:
        return {
          ...state,
          getInnovateChallengeIdDetailsLoading:false
        }


      case GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_STARTED:
        return {
          ...state,
          getInnovateChallengeListRemoveEvaluatorIsLoading:true
        }
      case GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_SUCCESS:
        return {
          ...state,
          getInnovateChallengeListRemoveEvaluatorIsLoading:false,
          getInnovateChallengeListRemoveEvaluator: action.response
          
        }
      case GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_FAILURE:
        return {
          ...state,
          getInnovateChallengeListRemoveEvaluatorIsLoading:false
        }


      case POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_STARTED:
        return {
          ...state,
          postInnovateChallengeRemoveEvaluatorIsLoading:true
        }
      case POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_SUCCESS:
        return {
          ...state,
          postInnovateChallengeRemoveEvaluatorIsLoading:false,
          postInnovateChallengeRemoveEvaluator: action.response
          
        }
      case POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_FAILURE:
        return {
          ...state,
          postInnovateChallengeRemoveEvaluatorIsLoading:false
        }

      case GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_STARTED:
        return {
          ...state,
          getIdeaListFromChallengeRemoveEvaluatorIsLoading:true
        }
      case GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_SUCCESS:
        return {
          ...state,
          getIdeaListFromChallengeRemoveEvaluatorIsLoading:false,
          getIdeaListFromChallengeRemoveEvaluator: action.response
          
        }
      case GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_FAILURE:
        return {
          ...state,
          getIdeaListFromChallengeRemoveEvaluatorIsLoading:false
        }


    

    default:
      return state
  }
}

export default InnovateChallengeReducer
